<template>
  <v-layout wrap>
    <v-flex
      xs12
      style="font-family: robotobold; font-size: 30px"
      text-center
      pt-8
      pt-lg-12
      >You May Also Like
    </v-flex>
    <v-flex xs12>
      <v-layout wrap px-md-12 pb-12>
        <v-flex sm6 md4 v-for="(item, i) in products" :key="i">
          <v-card flat>
            <v-layout wrap justify-center text-center px-10 py-6>
              <v-flex xs12 pb-2>
                <v-img max-height="500" :src="mediaURL + item.photos[0]">
                </v-img>
              </v-flex>
              <v-flex style="font-family: robotobold;" xs12 py-3>
                {{ item.productName }}
              </v-flex>
              <v-flex xs12>
                <span style="font-weight: bold">
                  Rs. {{ item.offerPrice.toFixed(2) }}
                </span>
                <span v-if="item.price!=item.offerPrice" style="color: gray">
                  <del> Rs. {{ item.price }}</del></span
                >
              </v-flex>
              <v-flex xs12 pt-3>
                <v-btn :href="'/productdetail?searchkey='+item._id" color="#080B0A" tile width="100%">
                  <span style="color: white; font-family: robotoregular">
                    view details</span
                  >
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      items: ["f2", "f1", "f3"],
      products: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      var data = {};
      data["productId"] = this.id;
      axios({
        method: "POST",
        url: "/product/suggestion/getlist",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.products = response.data.data;
          console.log(this.products);
        } else {
          console.log("no data ");
        }
      });
    },
     goTo(val) {
      this.$router.push({
        path: "/productdetail",
        query: {
          searchkey: val,
        },
      });
      console.log("val is=", val);
    },
  },
};
</script>